import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { Link } from 'react-router';

type LimitCode = 'FREE_REPORT_LIMIT_REACHED' | 'MONTHLY_REPORT_LIMIT_REACHED' | 'NO_REPORT_CREDITS_AVAILABLE' | null;

interface PlanLimitModalProps {
  open: boolean;
  code: LimitCode;
  onClose: () => void;
}

const MESSAGES: Record<NonNullable<LimitCode>, { title: string; description: string; ctas: Array<{ label: string; href: string }> }> = {
  FREE_REPORT_LIMIT_REACHED: {
    title: 'Freier Bericht bereits genutzt',
    description: 'Sie haben Ihren kostenlosen Testbericht bereits erstellt. Wählen Sie einen Tarif, um weitere Berichte zu erstellen.',
    ctas: [
      { label: 'Tarif wählen', href: '/preise' },
      { label: 'Einzelbericht kaufen', href: '/preise#einzelbericht' },
    ],
  },
  MONTHLY_REPORT_LIMIT_REACHED: {
    title: 'Berichtsguthaben aufgebraucht',
    description: 'Sie haben Ihr aktuelles Berichtsguthaben aufgebraucht. Kaufen Sie einen Einzelbericht oder wechseln Sie auf einen höheren Tarif.',
    ctas: [
      { label: 'Einzelbericht kaufen', href: '/preise#einzelbericht' },
      { label: 'Höheren Tarif wählen', href: '/preise' },
    ],
  },
  NO_REPORT_CREDITS_AVAILABLE: {
    title: 'Keine Bericht-Credits verfügbar',
    description: 'Sie haben keine weiteren Bericht-Credits. Kaufen Sie zusätzliche Credits oder wechseln Sie auf einen höheren Tarif.',
    ctas: [
      { label: 'Einzelbericht kaufen', href: '/preise#einzelbericht' },
      { label: 'Höheren Tarif wählen', href: '/preise' },
    ],
  },
};

export function PlanLimitModal({ open, code, onClose }: PlanLimitModalProps) {
  if (!code) return null;
  const content = MESSAGES[code];

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{content.title}</DialogTitle>
          <DialogDescription>{content.description}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 mt-2">
          {content.ctas.map((cta) => (
            <Button key={cta.href} asChild variant="default">
              <Link to={cta.href} onClick={onClose}>{cta.label}</Link>
            </Button>
          ))}
          <Button variant="ghost" onClick={onClose}>Schließen</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
